<div class="height-sem-proposta d-flex justify-content-center align-items-center">
  <div class="text-center">
    <h2 class="text-center">Nenhuma proposta foi criada ainda.</h2>
    <p>Aqui você acompanhará suas propostas.</p>
    <button class="btn btn-primary media-desktop" (click)="mostrarDetalhes()">Nova Proposta</button>
    <button class="btn btn-primary media-mobile" (click)="mostrarDetalhes()">Nova Proposta</button>
  </div>
</div>
